import { useTranslation } from "react-i18next";
import React, { useState, useEffect, Fragment, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Skeleton from "@mui/material/Skeleton";
import loadMaterialIcon from "../shared/functions/loadMaterialIcon";
import {
  Toolbar,
  Typography,
  Box,
  Button,
  Badge,
  ListItemButton,
  BottomNavigation,
  BottomNavigationAction,
  Menu,
  MenuItem,
  IconButton,
  Stack,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  Tooltip,
} from "@mui/material";
import { withStyles } from "@mui/styles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import { useLocalStorage, useSessionStorage } from "../../utils/hooks";
import ReplayIcon from "@mui/icons-material/Replay";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import NewVersion from "../NewVersionComponent/NewVersion";
import { VERSION } from "../../constants/version";
import { SearchTextField } from "../lib";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import MessageBox from "../shared/components/MessageBox";
import apiRequest from "../../functions/api";
import { useMessage } from "../../context/message-context";
import { useZulassung } from "../../context/zulassungs-context";
import MandantenAuswahl from "../MandantenAuswahl/MandantenAuswahl";
import { ContentCopy, Dashboard, DashboardOutlined, MoreVert, Star, StarBorder } from "@mui/icons-material";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import { fetchAufgaben } from "../ToDosComponent";
import { osName, osVersion } from "react-device-detect";
import { SchwarzesBrett } from "../SchwarzesBrett";

const styles = (theme) => ({
  paper: {
    margin: theme.spacing(2),
  },
  footerComponent: {
    borderTop: "1px solid " + theme.palette.background.light,
    backgroundColor: theme.palette.background.paper,
    position: "fixed",
    bottom: 0,
    width: "100%",
    touchAction: "none",
  },
  form: {
    margin: theme.spacing(1),
    flex: 1,
  },
  avatar: {
    color: theme.palette.getContrastText(theme.palette.secondary.main),
    backgroundColor: theme.palette.secondary.main,
  },
});
function HomeStandard(props) {
  const { t } = useTranslation();
  const { classes, title, updateTitle, allowedPrograms } = props;
  const [open, setOpen] = useState(false);
  const [activeProgram, setActiveProgram] = useState("");
  const [filter, setFilter] = useState("");
  const [latestVersion, setLatestVersion] = useState(localStorage.getItem(LOCAL_STORAGE_KEY.version) || VERSION);
  const [filteredPrograms, setFilteredPrograms] = useState([]);
  const [offeneAufgaben, setOffeneAufgaben] = useSessionStorage(LOCAL_STORAGE_KEY.offeneAufgaben);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const [verteilerHinweisText, setVerteilerHinweisText] = useState(null);
  const [zweiFaGeraet, setZweiFaGeraet] = useState({});
  const [zweiFaMessageBox, setZweiFaMessageBox] = useState(false);
  const { hideMessage, showErrorMessage, showSuccessMessage } = useMessage();

  const [verteilerHinweisTitel, setVerteilerHinweisTitel] = useState(null);
  const [accessToken] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);

  const { zulassung, updatePrograms, updateMandant, updateNewsAmount } = useZulassung();
  const [anchorEl, setAnchorEl] = useState(null);
  const [favoriteIndex, setFavoriteIndex] = useState(-1);
  const vertMenuOpen = Boolean(anchorEl);
  const handleVertMenuClick = (event, index) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
    setFavoriteIndex(index);
  };
  const handleVertMenuClose = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(null);
  };

  const programs = useMemo(() => zulassung.programs, [zulassung]);

  const navigate = useNavigate();

  const [gruppenWahl, setGruppenWahl] = useLocalStorage(LOCAL_STORAGE_KEY.selectedMenu);

  useEffect(() => {
    if (zulassung.programs.length === 0) {
      fetchPrograms();
    }
  }, []);

  useEffect(() => {
    if (zulassung?.programs?.find((e) => e.prg === "WEBAGU")) {
      const payload = {
        statement: "AUFGABENZAEHLER",
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "aufgaben", payload, headers, (response) => {
        if (response.status === 200) {
          setOffeneAufgaben(response?.data.aufgabenCount);
        } else {
          if (response.data.message) {
            showErrorMessage(response.message);
          } else {
            showErrorMessage("Keine Internetverbindung");
          }
        }
      });
    }
  }, [zulassung]);

  useEffect(() => {
    if (!gruppenWahl) {
      setGruppenWahl("sonstige");
    }
  }, [programs]);

  useEffect(() => {
    const tmpPrograms = zulassung.programs.filter(filterFunction);
    const sortedPrograms = tmpPrograms.sort((a, b) => a.name.localeCompare(b.name));
    setFilteredPrograms(sortedPrograms);
    setActiveProgram("");
  }, [filter, zulassung.programs, gruppenWahl]);

  useEffect(() => {
    if (title !== "") {
      updateTitle("");
    }
    // eslint-disable-next-line
  }, [title]);

  const handleFavoriteClick = (event) => {
    const selectedProgram = filteredPrograms[favoriteIndex].prg;

    var verteilerAction = "add";
    if (filteredPrograms[favoriteIndex].favorit) {
      verteilerAction = "remove";
    }
    event.stopPropagation();
    event.preventDefault();
    const payload = {
      program: selectedProgram,
      action: verteilerAction,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "set-favorite", payload, headers, favoriteCb);
    setAnchorEl(null);
  };

  const favoriteCb = (response) => {
    if (response.status === 200) {
      if (response.data.programs) {
        updatePrograms(response.data.programs);
      }
    }
  };

  const handleGruppenChange = (event, value) => {
    setGruppenWahl(value);
  };

  const verteilerCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      if (response.data.programs) {
        updatePrograms(response.data.programs);
      }
      if (response.data.zweiFaktor) {
        setZweiFaGeraet(response.data.zweiFaktor);
        setZweiFaMessageBox(true);
      }
      if (response.data.verteilerHinweisText) {
        setVerteilerHinweisText(response.data.verteilerHinweisText);
      }
      if (response.data.verteilerHinweisTitel) {
        setVerteilerHinweisTitel(response.data.verteilerHinweisTitel);
      }
      if (response.data.anzahlUngeleseneNews) {
        updateNewsAmount(Number(response.data.anzahlUngeleseneNews));
      }
      // if (response.data.aufgaben) {
      //   console.log("reset aufgaben: ", response.data.aufgaben)
      //   setOffeneAufgaben(response.data.aufgaben);
      // } else {
      //   setOffeneAufgaben("0");
      // }
      setActiveProgram("");
      setLatestVersion(response.data.version);
    } else {
      setIsError(true);
      showErrorMessage(response.data.message);
    }
  };

  const errorCb = (error) => {
    setIsLoading(false);
    setIsError(true);
    console.log("Es konnte keine Verbindung hergestellt werden");
  };

  const fetchPrograms = () => {
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    setIsLoading(true);
    apiRequest("GET", "verteiler", null, headers, verteilerCb, errorCb);
  };

  const filterFunction = (obj) => {
    if (!obj.name) return false;
    if (gruppenWahl === "favorit") {
      if (obj?.favorit) {
        return obj.name.toLowerCase().includes(filter.toLowerCase()) && (allowedPrograms.indexOf(obj.prg) !== -1 || obj.iv);
      } else {
        return false;
      }
    }
    if (gruppenWahl === "sonstige") {
      return obj.name.toLowerCase().includes(filter.toLowerCase()) && (allowedPrograms.indexOf(obj.prg) !== -1 || obj.iv);
    }
    if (obj?.gruppe !== gruppenWahl) {
      return false;
    }
    return obj.name.toLowerCase().includes(filter.toLowerCase()) && (allowedPrograms.indexOf(obj.prg) !== -1 || obj.iv);
  };
  // const filterFunction = (obj) => {
  //   if (!obj.name) return false;
  //   return (
  //     obj.name.toLowerCase().includes(filter.toLowerCase()) &&
  //     (allowedPrograms.indexOf(obj.prg) !== -1 || obj.iv)
  //   );
  // };
  const openMessageBox = () => {
    setMessageBoxOpen(true);
  };

  const closeMessageBox = () => {
    setMessageBoxOpen(false);
  };

  function messageBoxResult(r) {
    closeMessageBox();
  }

  const handleClientChange = () => {
    const tmpPrograms = [...zulassung.programs];
    const tmpPgm = tmpPrograms.find((pgm) => {
      return pgm.prg === activeProgram;
    });
    if (tmpPgm.notif > 0) {
      tmpPgm.notif = 0;
      updatePrograms([...tmpPrograms]);
    }
    updateTitle(tmpPgm.name);
    navigate("/" + tmpPgm.prg);
  };

  if (isLoading) {
    return (
      <Page>
        <Layout>
          <Toolbar>
            <form className={classes.form}>
              <SearchTextField fullWidth value={filter} label={t("Suche")} variant="outlined" aria-label="Search" onChange={() => console.log("")} disabled />
            </form>
          </Toolbar>
          <List>
            <Divider variant="inset" component="li" light />
            <ListItem key="loading1">
              <ListItemAvatar>
                <Skeleton variant="circular" animation="wave" width={40} height={40} />
              </ListItemAvatar>
              <ListItemText primary={<Skeleton variant="text" animation="wave" />} secondary={<Skeleton variant="text" animation="wave" />} />
            </ListItem>
            <Divider variant="inset" component="li" light />
            <ListItem key="loading2">
              <ListItemAvatar>
                <Skeleton variant="circular" animation="wave" width={40} height={40} />
              </ListItemAvatar>
              <ListItemText primary={<Skeleton variant="text" animation="wave" />} secondary={<Skeleton variant="text" animation="wave" />} />
            </ListItem>
            <Divider variant="inset" component="li" light />
            <ListItem key="loading3">
              <ListItemAvatar>
                <Skeleton variant="circular" animation="wave" width={40} height={40} />
              </ListItemAvatar>
              <ListItemText primary={<Skeleton variant="text" animation="wave" />} secondary={<Skeleton variant="text" animation="wave" />} />
            </ListItem>
          </List>
        </Layout>
      </Page>
    );
  }
  const displayPrograms =
    zulassung.programs.length > 0 ? (
      filteredPrograms.length > 0 ? (
        filteredPrograms.map((dataObject, count) => {
          const name = dataObject.name;
          const description = dataObject.description;
          if (dataObject.mandanten) {
            if (dataObject.mandanten.length === 1) {
              return (
                <Fragment key={"f" + count.toString()}>
                  <Divider key={"d" + count.toString()} variant="inset" component="li" light />
                  <ListItemButton
                    key={"v" + count.toString()}
                    onClick={() => {
                      if (dataObject.notif > 0) {
                        const tmpPrograms = [...zulassung.programs];
                        const tmpPgm = tmpPrograms.find((pgm) => {
                          return pgm.prg === dataObject.prg;
                        });
                        tmpPgm.notif = 0;
                        updatePrograms(tmpPrograms);
                      }
                      updateMandant(dataObject.mandanten[0].key);
                      updateTitle(dataObject.name);
                      navigate("/" + dataObject.prg);
                    }}
                  >
                    <ListItemAvatar>
                      <Badge badgeContent={dataObject.notif} color="error" overlap="circular" style={{ zIndex: 0 }}>
                        <Avatar className={classes.avatar}>{loadMaterialIcon(dataObject.icon)}</Avatar>
                      </Badge>
                    </ListItemAvatar>
                    <ListItemText primary={name} secondary={description} />
                    {dataObject.favorit && <Star color="secondary" />}
                    <IconButton onClick={(e) => handleVertMenuClick(e, count)}>
                      <MoreVert />
                    </IconButton>
                  </ListItemButton>
                </Fragment>
              );
            } else {
              return (
                <Fragment key={"f" + count.toString()}>
                  <Divider key={"d" + count.toString()} variant="inset" component="li" light />
                  <ListItemButton
                    key={"v" + count.toString()}
                    onClick={() => {
                      setActiveProgram(dataObject.prg);
                      setOpen(true);
                    }}
                  >
                    <ListItemAvatar>
                      <Badge badgeContent={dataObject.notif} color="error" overlap="circular" style={{ zIndex: 0 }}>
                        <Avatar className={classes.avatar}>{loadMaterialIcon(dataObject.icon)}</Avatar>
                      </Badge>
                    </ListItemAvatar>
                    <ListItemText primary={name} secondary={description} />
                    {dataObject.favorit && <Star color="secondary" />}
                    <IconButton onClick={(e) => handleVertMenuClick(e, count)}>
                      <MoreVert />
                    </IconButton>
                  </ListItemButton>
                </Fragment>
              );
            }
          } else {
            return (
              <Fragment key={"f" + count.toString()}>
                <Divider key={"d" + count.toString()} variant="inset" component="li" light />
                <ListItemButton
                  key={"v" + count.toString()}
                  disabled={dataObject.noAccess == "1"}
                  onClick={() => showErrorMessage("Sie haben keinen Zugriff auf dieses Programm.")}
                >
                  <ListItemAvatar>
                    <Avatar className={classes.avatar}>{loadMaterialIcon(dataObject.icon)}</Avatar>
                  </ListItemAvatar>
                  <Box>
                    <ListItemText primary={name} secondary={description} />                    
                    {dataObject.grund && 
                      <Typography color={"error"}>{dataObject.grund}</Typography>
                    }
                  </Box>
                </ListItemButton>
              </Fragment>
            );
          }
        })
      ) : gruppenWahl === "favorit" && filter === "" ? (
        <Fragment key={"f00"}>
          <Divider key={"d00"} variant="inset" component="li" light />
          <ListItem key={"v00"}>
            <ListItemText primary={"Sie haben noch keine Favoriten"} secondary={"Fügen Sie ein Programm als Favorit hinzu um es hier zu sehen"} />
          </ListItem>
        </Fragment>
      ) : (
        <Fragment key={"f00"}>
          <Divider key={"d00"} variant="inset" component="li" light />
          <ListItem key={"v00"}>
            <ListItemText primary={"Keine Programme gefunden"} secondary={"Bitte passen Sie ihre Suche an"} />
          </ListItem>
        </Fragment>
      )
    ) : (
      <Fragment key={"f00"}>
        <Divider key={"d00"} variant="inset" component="li" light />
        <ListItem key={"v00"}>
          <ListItemText
            primary={"Herzlich Willkommen in der ectool-App"}
            secondary={"Sobald Ihr Account freigeschalten wurde, können Sie hier alle Funktionen der App sehen."}
          />
        </ListItem>
      </Fragment>
    );

  if (isError) {
    return (
      <Box p={2}>
        <Typography>{t("Programme konnten nicht geladen werden.")}</Typography>
        <Button variant="contained" color="primary" onClick={fetchPrograms} startIcon={<ReplayIcon />}>
          {t("Erneut versuchen")}
        </Button>
      </Box>
    );
  }

  const newsButton = () => {
    return (
      <Button xs={{ margin: 2 }} color="inherit" size="small" onClick={() => navigate("/NEWS")}>
        {t("Mehr Info")}
      </Button>
    );
  };

  return (
    <>
      <Page>
        <MessageBox
          title={verteilerHinweisTitel}
          text={verteilerHinweisText}
          buttons="OK"
          onClose={closeMessageBox}
          open={messageBoxOpen}
          handleResponse={messageBoxResult}
        />
        <Dialog
          open={zweiFaMessageBox}
          onClose={setZweiFaMessageBox}
          fullWidth
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          sx={{ padding: 4, borderRadius: 2 }}
        >
          <DialogTitle id="alert-dialog-title">
            <Typography variant="h4" sx={{ marginBottom: 2 }}>
              Sicherheitswarnung
            </Typography>
          </DialogTitle>
          <DialogContent sx={{ padding: 2 }}>
            <Typography variant="body1" sx={{ marginBottom: 2 }}>
              Sie haben sich um {zweiFaGeraet?.loginUhrzeit} von einem neuen Gerät: '{zweiFaGeraet?.bez}' angemeldet.
            </Typography>
            <Typography variant="h6" sx={{ marginBottom: 2 }}>
              Ihr Verifizierungscode lautet:{" "}
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {zweiFaGeraet?.code}
                </Typography>{" "}
                <Tooltip title="TAN kopieren">
                  <IconButton
                    color="primary"
                    onClick={() => {
                      navigator.clipboard.writeText(zweiFaGeraet?.code);
                      showSuccessMessage("Der TAN wurde in die Zwischenablage kopiert");
                    }}
                  >
                    <ContentCopy />
                  </IconButton>
                </Tooltip>
              </Box>
            </Typography>
            <Typography variant="body1" color={""} sx={{ fontWeight: 400 }}>
              Sollten Sie sich nicht angemeldet haben setzen Sie sich bitte umgehend mit Ihrer Personalabteilung in Verbindung, um Missbrauch mit dem Zugang zu
              vermeiden.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setZweiFaMessageBox(false)} color="primary" variant="contained">
              OK
            </Button>
          </DialogActions>
        </Dialog>
        {/* <MessageBox
          title={"2-Faktor-Authentifizierung"}
          text={"Sie haben sich um "+zweiFaGeraet?.loginUhrzeit+" auf einem weiteren Gerät mit der Kennung: "+zweiFaGeraet?.kennung+" angemeldet."}
          buttons="OK"
          onClose={setZweiFaMessageBox}
          open={zweiFaMessageBox}
          handleResponse={()=>setZweiFaMessageBox(false)} */}

        {verteilerHinweisText && (
          <Layout fullWidth>
            <Button onClick={openMessageBox} variant="text" color="primary">
              {verteilerHinweisTitel}
            </Button>
          </Layout>
        )}
        <NewVersion latestVersion={latestVersion} />

        <Layout>
          <Toolbar>
            <Stack spacing={1} sx={{ flexGrow: 1, marginTop: 1 }}>
              <SchwarzesBrett></SchwarzesBrett>
              {zulassung.newsAmount > 0 && (
                <Alert
                  sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                  severity="info"
                  variant="filled"
                  iconMapping={{
                    info: <NewspaperIcon fontSize="inherit" />,
                  }}
                  action={<>{newsButton()}</>}
                >
                  {zulassung.newsAmount === 1 && (
                    <Stack direction={"row"} spacing={1}>
                      <Typography>
                        <Box sx={{ fontWeight: "bold" }} component="span">
                          {zulassung.newsAmount}
                        </Box>
                        {t(" neue Programmanpassung")}
                      </Typography>
                    </Stack>
                  )}
                  {zulassung.newsAmount > 1 && (
                    <Stack direction={"row"} spacing={1}>
                      <Typography>
                        <Box sx={{ fontWeight: "bold" }} component="span">
                          {zulassung.newsAmount}
                        </Box>
                        {t(" neue Programmanpassungen")}
                      </Typography>
                    </Stack>
                  )}
                </Alert>
              )}
              <form className={classes.form}>
                <SearchTextField
                  fullWidth
                  size="small"
                  label={t("Suche")}
                  variant="outlined"
                  aria-label="Search"
                  id="filter"
                  value={filter}
                  inputProps={{
                    autoCapitalize: "off",
                    autoCorrect: "off",
                    spellCheck: "false",
                    autoComplete: "off",
                  }}
                  onChange={(e) => setFilter(e.target.value)}
                />
              </form>
            </Stack>
          </Toolbar>
          <List>{displayPrograms}</List>
          <Menu anchorEl={anchorEl} open={vertMenuOpen} onClose={handleVertMenuClose}>
            {filteredPrograms[favoriteIndex]?.favorit ? (
              <MenuItem onClick={handleFavoriteClick}>Aus Favoriten entfernen</MenuItem>
            ) : (
              <MenuItem onClick={handleFavoriteClick}>Zu Favoriten hinzufügen</MenuItem>
            )}
          </Menu>
          <MandantenAuswahl onClick={handleClientChange} program={activeProgram} open={open} setOpen={setOpen} />
        </Layout>
        <Layout fullWidth>
          {/*SB: fullWidth war hier mal als Prop dabei. Hat Warnungen verursacht da der prop nicht existiert. Bei Problemen wieder einfügen */}
          <BottomNavigation style={{ visibility: "hidden" }}></BottomNavigation>
          {/* <Box className="ectool-safe-area-top"></Box> */}
          {osName === "Android" && Number(osVersion) >= 15 ? <div className="ectool-safe-area-bottom"></div> : <div className="ectool-safe-area-bottom"></div>}
        </Layout>
      </Page>
      <div className={classes.footerComponent}>
        {/*SB: fullWidth war hier mal als Prop dabei. Hat Warnungen verursacht da der prop nicht existiert. Bei Problemen wieder einfügen */}
        <BottomNavigation value={gruppenWahl} onChange={handleGruppenChange} showLabels>
          <BottomNavigationAction label={t("Favoriten")} icon={gruppenWahl === "favorit" ? <Star /> : <StarBorder />} value={"favorit"} disableRipple />
          <BottomNavigationAction
            label={t("Menu")}
            icon={gruppenWahl === "sonstige" ? <Dashboard /> : <DashboardOutlined />}
            value={"sonstige"}
            disableRipple
          />
        </BottomNavigation>
        {/* <div className="ectool-safe-area-top"></div> */}
        {osName === "Android" && Number(osVersion) >= 15 ? <div className="ectool-safe-area-bottom"></div> : <div className="ectool-safe-area-bottom"></div>}
      </div>
    </>
  );
}
export default withStyles(styles)(HomeStandard);
